import { render, staticRenderFns } from "./model.vue?vue&type=template&id=421885d0&scoped=true"
import script from "./model.vue?vue&type=script&lang=js"
export * from "./model.vue?vue&type=script&lang=js"
import style0 from "./model.vue?vue&type=style&index=0&id=421885d0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421885d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('421885d0')) {
      api.createRecord('421885d0', component.options)
    } else {
      api.reload('421885d0', component.options)
    }
    module.hot.accept("./model.vue?vue&type=template&id=421885d0&scoped=true", function () {
      api.rerender('421885d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sportManage/message/tabs/model.vue"
export default component.exports